export function getShellState() {
  return {
    namespaced: true,
    state: {
      userFullName: null,
      userEmail: null,
      userPicture: null,
      currentOrganizationName: null,
      currentOrganizationId: null,
      currentOrganizationPermissions: [],
      switchableOrganizations: [],

      userOrganizationName: null,
      userOrganizationId: null,

      snackBar: {
        display: false,
        color: "green",
        text: "Snackbar message"
      }
    },
    mutations: {
      SET_SNACKBAR: function(state, data) {
        state.snackBar = {
          ...state.snackBar,
          ...data
        };
      },
      SET_FULL_NAME: function(state, data) {
        state.userFullName = data;
      },
      SET_EMAIL: function(state, data) {
        state.userEmail = data;
      },
      SET_PICTURE: function(state, data) {
        state.userPicture = data;
      },
      SET_SWITCHABLE_ORGANIZATIONS: function(state, data) {
        state.switchableOrganizations = data;
      },
      SET_CURRENT_ORGANIZATION_NAME: function(state, payload) {
        state.currentOrganizationName = payload;
      },
      SET_CURRENT_ORGANIZATION_ID: function(state, payload) {
        state.currentOrganizationId = payload;
      },
      SET_CURRENT_ORGANIZATION_PERMISSIONS: function(state, data) {
        state.currentOrganizationPermissions = data;
      },
      SET_USER_ORGANIZATION_NAME: function(state, data) {
        state.userOrganizationName = data;
      },
      SET_USER_ORGANIZATION_ID: function(state, data) {
        state.userOrganizationId = data;
      },
      CLEAR_ORGANIZATION_DATA: function(state) {
        state.userFullName = null;
        state.userEmail = null;
        state.userPicture = null;
        state.currentOrganizationName = null;
        state.currentOrganizationId = null;
        state.currentOrganizationPermissions = [];
        state.userSwitchableOrganizations = [];
        state.userOrganizationName = null;
        state.userOrganizationId = null;
      }
    },
    getters: {
      userOrganizationName({ state }) {
        return state.userOrganizationName;
      },
      userOrganizationId({ state }) {
        return state.userOrganizationId;
      },
      currentOrganizationName({ state }) {
        return state.currentOrganizationName;
      },
      currentOrganizationId({ state }) {
        return state.currentOrganizationId;
      },
      switableOrganizations({ state }) {
        return state.getSwitableOrganizations;
      },
      currentOrganizationPermissions({ state }) {
        return state.currentOrganizationPermissions;
      }
    },
    actions: {
      showSnackbar({ commit }, data) {
        commit("SET_SNACKBAR", { ...data, display: true });
      },
      hideSnackbar({ commit }) {
        commit("SET_SNACKBAR", { display: false });
      }
    },
    modules: {}
  };
}
